export enum ClientListTermsStatus {
  Pending = 'pending',
  Requested = 'requested',
  Rejected = 'rejected',
  Accepted = 'accepted',
}

export enum ClientListKycStatus {
  Pending = 'pending',
  Waiting = 'requested', // backend doesn't send this status yet
  Approved = 'approved',
  Rejected = 'rejected',
}

export type ClientListItem = {
  company_id: string
  company_name: string
  company_document_number: string
  register_date: string
  terms_status: ClientListTermsStatus
  kyc_status: ClientListKycStatus
  limit: number | null
  available_limit: number | null
  is_limit_blocked?: boolean
}

export class ClientList {
  constructor(item: ClientListItem) {
    Object.assign(this, item)
  }

  get hasLimit() {
    return this.limit !== null && this.limit > 0 && !this.hasLimitBlocked
  }

  get hasLimitBlocked() {
    return this.is_limit_blocked === true
  }

  // OPT IN
  get hasOptIn() {
    return this.terms_status === ClientListTermsStatus.Accepted
  }

  get hasOptInPending() {
    return this.terms_status === ClientListTermsStatus.Pending
  }

  get hasOptInRejected() {
    return this.terms_status === ClientListTermsStatus.Rejected
  }

  get hasOptInRequested() {
    return this.terms_status === ClientListTermsStatus.Requested
  }

  get termsStatus() {
    if (this.hasOptIn) return ClientListTermsStatus.Accepted
    if (this.hasOptInRejected) return ClientListTermsStatus.Rejected
    if (this.hasOptInRequested) return ClientListTermsStatus.Requested

    return ClientListTermsStatus.Pending
  }

  // CREDIT LIMIT
  get hasCreditApproved() {
    return (
      this.hasOptIn &&
      this.hasLimit &&
      this.kyc_status === ClientListKycStatus.Approved
    )
  }

  get hasCreditPending() {
    return !this.hasOptIn || this.kyc_status === ClientListKycStatus.Pending
  }

  get hasCreditWaiting() {
    return this.hasLimit && this.kyc_status === ClientListKycStatus.Waiting
  }

  get hasCreditRejected() {
    return (
      this.hasOptIn &&
      (!this.hasLimit || this.kyc_status === ClientListKycStatus.Rejected)
    )
  }

  get creditStatus() {
    if (this.hasCreditApproved) return ClientListKycStatus.Approved
    if (this.hasCreditRejected) return ClientListKycStatus.Rejected
    if (this.hasCreditPending) return ClientListKycStatus.Pending
    if (this.hasCreditWaiting) return ClientListKycStatus.Waiting

    return ClientListKycStatus.Pending
  }
}

export interface ClientList extends ClientListItem {}
